import React, { Component } from "react";

import Api from "../../lib/componentApi";
import getAppErrors from "../../lib/appErrors";
import validateForm from "../../lib/validateForm";

import AppErrors from "../Common/AppErrors";

export default class RestorePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formErrors: {
        password: "",
        confirmPassword: ""
      },
      password: "",
      confirmPassword: "",
      active: false,
      errorMessage: null,
      showErrors: false
    };
  }
  onClickClose = () => {
    this.setState({
      errorMessage: null
    });
  };
  isValid = () => {
    const { password, confirmPassword, formErrors } = this.state;
    const errors = Object.values(formErrors).filter(Boolean);
    if (password && confirmPassword && !errors.length) {
      if (password === confirmPassword) {
        return true;
      } else {
        this.setState(
          {
            formErrors: {
              ...formErrors,
              confirmPassword:
                "Your password and confirmation password do not match."
            },
            showErrors: true
          },
          () => false
        );
      }
    } else {
      this.setState(
        {
          showErrors: true
        },
        () => {
          return false;
        }
      );
    }
  };
  handleSubmit = event => {
    event.preventDefault();
    const isValid = this.isValid();
    if (isValid) {
      const { password } = this.state;
      const { passKey } = this.props;
      Api.post(
        "/api/restorePass",
        { key: passKey, password },
        (response, errors) => {
          if (errors) {
            if (errors === 503) {
              this.setState(() => {
                throw errors;
              });
            } else {
              console.log(errors);
            }
          } else if (response.code) {
            const errorMessage = getAppErrors(response.code);
            this.setState({
              errorMessage:
                (errorMessage && errorMessage.message) || response.message
            });
          } else {
            window.location.href = "https://www.burdiapp.com/personal";
          }
        }
      );
    }
  };
  handleChange = event => {
    event.preventDefault();
    const input = event.target.id;
    this.setState(
      {
        [input]: event.target.value,
        showErrors: false
      },
      () => {
        const currentState = { [input]: this.state[input] };
        const inputError = validateForm(currentState, "restorePass");
        const { formErrors } = this.state;
        formErrors[input] = inputError;
        this.setState({ formErrors }, () => {
          const { password, confirmPassword, formErrors } = this.state;
          const errors = Object.values(formErrors).filter(Boolean);
          if (password === confirmPassword && !errors.length) {
            this.setState({ active: true });
          } else {
            this.setState({ active: false });
          }
        });
      }
    );
  };
  render() {
    const { handleCloseSection } = this.props;
    const {
      password,
      confirmPassword,
      formErrors,
      active,
      errorMessage,
      showErrors
    } = this.state;

    return (
      (errorMessage && (
        <AppErrors message={errorMessage} onClickClose={this.onClickClose} />
      )) || (
        <div className="container">
          <div className="sign-page forgot-page restore-page">
            {/* Header */}
            <div className="head-general with-back visible-xs">
              <a
                href="javascript: void(0)"
                className="back"
                onClick={() => handleCloseSection("restorePass")}
              >
                <img src="/png/chevron-left.png" />
              </a>
              <h4>Restore Password</h4>
              <a href="javascript: void(0)" className="close" />
            </div>
            {/* Header */}
            <div className="row center-sm">
              <div className="col-sm-6">
                <h5 className="hide-xs">Restore Password</h5>
                <form onSubmit={this.handleSubmit} className="Login">
                  <div
                    className={`form-group ${(showErrors &&
                      formErrors["password"] &&
                      "error") ||
                      ""}`}
                  >
                    <input
                      id="password"
                      className="form-input"
                      value={password}
                      autoCapitalize="none"
                      autoComplete="password"
                      type="password"
                      placeholder="password"
                      onChange={this.handleChange}
                    />
                    <span>
                      {(showErrors &&
                        formErrors["password"] &&
                        formErrors["password"]) ||
                        ""}
                    </span>
                  </div>
                  <div
                    className={`form-group ${(showErrors &&
                      formErrors["confirmPassword"] &&
                      "error") ||
                      ""}`}
                  >
                    <input
                      id="confirmPassword"
                      className="form-input"
                      value={confirmPassword}
                      autoCapitalize="none"
                      autoComplete="password"
                      type="password"
                      placeholder="confirm password"
                      onChange={this.handleChange}
                    />
                    <span>
                      {(showErrors &&
                        formErrors["confirmPassword"] &&
                        formErrors["confirmPassword"]) ||
                        ""}
                    </span>
                  </div>
                  <div className="">
                    <button
                      className={`btn btn-sign register-button ${(active &&
                        "active") ||
                        ""}`}
                      type="submit"
                    >
                      <span>Submit</span>
                    </button>
                  </div>
                </form>
              </div>
              {/* .col-sm-6 */}
            </div>
            {/* .row */}
          </div>
          {/* .restore-page */}
        </div>
      )
    );
  }
}
